<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div class="row px-0 mx-0 align-items-center" v-bind="attrsStylesClass">
		<h5 class="display-inline-block mb-0">
			<strong>
				<div v-if="hideBack" class="page-heading-crumbs my-auto col card-title px-0 d-flex align-items-center">
					<slot>
						{{ title }}
					</slot>
				</div>
				<div v-else class="cursor-pointer page-heading-crumbs my-auto col card-title py-2 pr-2 pl-0 d-flex align-items-center"
					 @click="onClick">
					<qw-button-icon icon="icon-left-open-big"/>
					<slot>{{ title }}</slot>
				</div>
			</strong>
		</h5>

		<slot name="append"></slot>

	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "BackHeader",
	extends: BaseComponent,
	props: {
		title: String,
		hideBack: Boolean,
		backRoute: [Object, String],
	},

	inheritAttrs: false,

	methods: {
		onClick() {
			if(this.backRoute){
				return this.go(this.backRoute)
			}
			this.$emit("onBackClicked")
			this.$emit("click")
		}
	}
}
</script>

<style>

</style>
